const themes = {
  light: {
    'version.list.body.shadow': '0 1px 3px 0 rgba(0,0,0,0.08), 0 4px 6px 0 rgba(50,50,93,0.11)',
    'version.list.column.title.color': 'rgba(0,0,0,0.4)',
    'version.list.item.bg.color': '#FFFFFF',
    'version.list.separation.line.color': '#D9D9DE',
    'version.list.text.color': 'rgba(0,0,0,0.6)',
  },
  dark: {
    'version.list.body.shadow': '0 1px 3px 0 rgba(0,0,0,0.08), 0 4px 6px 0 rgba(0,0,0,0.12)',
    'version.list.column.title.color': 'rgba(255,255,255,0.4)',
    'version.list.item.bg.color': '#263142',
    'version.list.separation.line.color': 'rgba(255,255,255,0.1)',
    'version.list.text.color': 'rgba(255,255,255,0.8)',
  },
};

export default themes;
